// Visit The Stimulus Handbook for more details
// https://stimulusjs.org/handbook/introduction
//
// This example controller works with specially annotated HTML like:
//
// <div data-controller="hello">
//   <h1 data-target="hello.output"></h1>
// </div>

import { Controller } from "stimulus";

const resetSelectButtons = (ratingScale) => {
  // Clear all possible rating scale classes and hide all pills first
  for (let i = 1; i <= 6; i++) {
    const element = document.getElementById(`comp-rating-val-${i}`);
    if (element) {
      element.className = "comp-rating-pill";
      element.style.display = "none";
    }
  }

  // Hide the description section
  const descriptionSection = document.getElementById(
    "rating-description-section"
  );
  if (descriptionSection) {
    descriptionSection.style.display = "none";
  }
};

const populateRatingScale = (ratingScale, selectedValue) => {
  // Show and populate the relevant rating scale pills
  if (ratingScale && Array.isArray(ratingScale)) {
    ratingScale.forEach((scaleItem) => {
      const element = document.getElementById(
        `comp-rating-val-${scaleItem.value}`
      );
      if (element) {
        element.style.display = "flex";
        element.innerHTML = `${scaleItem.value} - ${scaleItem.short}`;

        // Highlight the selected value
        if (scaleItem.value === selectedValue) {
          element.classList.add(`comp-rating-pill-val-${selectedValue}`);
        }
      }
    });
  }
};

const populateRatingDescription = (ratingScale, selectedValue) => {
  const descriptionSection = document.getElementById(
    "rating-description-section"
  );
  const badge = document.getElementById("rating-description-badge");
  const title = document.getElementById("rating-description-title");
  const text = document.getElementById("rating-description-text");

  if (!ratingScale || !Array.isArray(ratingScale) || !descriptionSection) {
    return;
  }

  // Find the selected rating item
  const selectedRating = ratingScale.find(
    (item) => item.value === selectedValue
  );

  if (selectedRating) {
    // Show the description section
    descriptionSection.style.display = "block";

    // Populate the badge with dynamic styling
    badge.innerHTML = `${selectedRating.value}`;
    badge.className = `rating-description-badge comp-rating-pill-val-${selectedValue}`;

    // Set the title
    title.innerHTML = `${selectedRating.short}`;

    // Set the description text
    text.innerHTML =
      selectedRating.description || "No detailed description available.";
  } else {
    descriptionSection.style.display = "none";
  }
};

export default class extends Controller {
  connect() {
    console.log("Hello, checked comp");
  }

  populateModal = (e) => {
    console.log("POPULATE", e.target.dataset.cr);
    let header = document.getElementById("exampleModalLabel");
    header.innerHTML = "";
    let pill = document.createElement("div");
    let header_row = document.createElement("div");
    let header_section = document.createElement("div");
    let comments_section = document.getElementById("modal-preceptor-comments");
    let subc_list = document.getElementById("subcompetencies-list");

    // Clear previous content
    subc_list.innerHTML = "";
    comments_section.innerHTML = "Loading...";

    header_row.classList.add("comp-rating-line");
    pill.classList.add("comp-rating-pill");

    $.ajax({
      url: `/competency_ratings/${e.target.dataset.cr}.json`,
      method: "GET",
      contentType: "application/json",
      success: function (response) {
        let comp_rating = response.competency_rating;
        console.log("SUCCESS!!!!", response);

        // Reset all buttons and populate with the correct rating scale
        resetSelectButtons(comp_rating.rating_scale);
        populateRatingScale(comp_rating.rating_scale, comp_rating.rating_value);
        populateRatingDescription(
          comp_rating.rating_scale,
          comp_rating.rating_value
        );

        // Set the modal title
        let header_text = document.createTextNode(
          comp_rating.competency_name || "Competency Rating"
        );
        header_section.appendChild(header_text);
        header_row.appendChild(header_section);
        header.appendChild(header_row);

        // Set comments with better formatting
        const commentsText = comp_rating.comments || "No comments provided";
        comments_section.innerHTML =
          commentsText === "No comments provided"
            ? `<em class="text-muted">${commentsText}</em>`
            : commentsText;

        // Populate subcompetencies
        if (
          comp_rating.subcompetencies &&
          comp_rating.subcompetencies.length > 0
        ) {
          comp_rating.subcompetencies.forEach((subcomp) => {
            let li = document.createElement("li");
            li.classList.add("list-group-item");
            li.innerHTML = `<i class="fas fa-check-circle text-success me-2"></i>${subcomp.name}`;
            subc_list.appendChild(li);
          });
        } else {
          let li = document.createElement("li");
          li.classList.add("list-group-item", "text-muted");
          li.innerHTML = `<em><i class="fas fa-info-circle me-2"></i>No subcompetencies defined for this competency</em>`;
          subc_list.appendChild(li);
        }
      },
      error: function (xhr, status, error) {
        console.error("Error loading competency rating:", error);
        let comments_section = document.getElementById(
          "modal-preceptor-comments"
        );
        comments_section.innerHTML = `<em class="text-danger"><i class="fas fa-exclamation-triangle me-2"></i>Error loading comments</em>`;

        // Clear the pills on error
        resetSelectButtons([]);
      },
    });
  };
}
